/*global $*/
/*eslint no-undef: "error"*/
export default class TabGallery {
    classItem = 'gallery--item'
    classButton = 'gallery--button'
    classBlock = 'gallery--block'

    classButtonActive = 'gallery__tab-active'
    classBlockActive = 'gallery__block-active'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let block = $(this).data('block')

            $(`.${self.classButton}`).closest(`.${self.classItem}`).find(`.${self.classButton}`).removeClass(self.classButtonActive)
            $(this).addClass(self.classButtonActive)

            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}`).removeClass(self.classBlockActive)
            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}[data-block='${block}']`).addClass(self.classBlockActive)
        })
    }
}
